
import * as defaultImport from "@splunk/react-icons/MagnifierPlus";
export * from "@splunk/react-icons/MagnifierPlus";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
